
// TODO fix short names and sort index

export default [{
    name: 'Фермерское хоз-во', // 'Фермерское хозяйство',
    key: 'farm',
}, {
    name: 'Личное подсобное хозяйство',
    key: 'privateFarm'
}, {
    name: 'Участок сельскохозяйственного назначения',
    key: 'forAgriculturalPurposes',
}, {
    name: 'Садоводство',
    key: 'gardening',
}, {
    name: 'Садовое некоммерческое товарищество',
    key: 'gardeningNonProfitPartnership',
}, {
    name: 'ИЖС', // 'Индивидуальное жилищное строительство',
    key: 'individualHousingConstruction',
}, {
    name: 'Земля промназначения', // 'Земля промышленного назначения',
    key: 'industrialLand',
}, {
    name: 'Участок промышленности, транспорта, связи и иного не сельхоз. назначения',
    key: 'industryTransportCommunications',
}, {
    name: 'Инвестпроект',
    key: 'investmentProject',
}, {
    name: 'Особо охраняемых категорий',
    key: 'ofProtectedCategories',
}, {
    name: 'Участок запаса',
    key: 'reserve',
}, {
    name: 'ДНП', // 'Дачное некоммерческое партнерство',
    key: 'suburbanNonProfitPartnership',
}, {
    name: 'Дачное некоммерческое партнерство поселений',
    key: 'suburbanNonProfitSettlementsPartnership',
}, {
    name: 'Участок водного фонда',
    key: 'waterArea',
}];
